import React from 'react';

import { Navigate, RouteObject } from 'react-router-dom';

import {
  ForbiddenView,
  LandingView,
  SummaryView,
  APIView,
  SorryPageView,
  FeedbackView,
  SomethingMissing,
  LoginView,
  MeteringView,
  EstimatorView
} from 'pages';

import {
  AppLayoutWrapper,
  LandingLayoutWrapper,
  SupportWrapper,
  CostsWrapper
} from './wrapper';
import config from 'config';
import { CoverageCheckV2InputView } from 'pages/CoverageCheck/v2';
import { NDAGenerator } from 'app/components/Sections';

const NotFound = {
  path: '*',
  element: <Navigate to="/401" />
};

export const Routes = (isLoggedIn: boolean): RouteObject[] => [
  {
    path: config.APP.PATH.FORBIDDEN,
    element: <ForbiddenView />,
    children: [{ ...NotFound }]
  },
  {
    path: config.APP.PATH.LOGIN,
    element: <LandingLayoutWrapper />,
    children: [
      {
        path: '',
        element: <LoginView />
      },
      { ...NotFound }
    ]
  },
  {
    path: config.APP.PATH.LANDING,
    element: <AppLayoutWrapper isLoggedIn={isLoggedIn} />,
    children: [
      {
        path: '',
        element: <LandingView />
      },
      {
        path: 'summary',
        element: <SummaryView />
      },
      {
        path: 'coverage-check',
        element: <CoverageCheckV2InputView />
      },
      {
        path: 'nda-generator',
        element: <NDAGenerator />
      },
      {
        path: 'api/:api',
        element: <APIView />
      },
      { ...NotFound }
    ]
  },
  {
    path: config.APP.PATH.SUPPORT,
    element: <SupportWrapper isLoggedIn={isLoggedIn} />,
    children: [
      {
        path: '',
        element: <SomethingMissing />
      },
      {
        path: 'something-missing',
        element: <SomethingMissing />
      },
      {
        path: 'feedback',
        element: <FeedbackView />
      },
      { ...NotFound }
    ]
  },
  {
    path: '401',
    element: <ForbiddenView />,
    children: [{ ...NotFound }]
  },
  {
    path: config.APP.PATH.SORRY,
    element: <SorryPageView />,
    children: [{ ...NotFound }]
  },
  {
    path: config.APP.PATH.COSTS,
    element: <CostsWrapper isLoggedIn={isLoggedIn} />,
    children: [
      {
        path: 'metering',
        element: <MeteringView />
      },
      {
        path: 'estimator',
        element: <EstimatorView />
      },
      { ...NotFound }
    ]
  }
];
